import { useQuery } from '@apollo/client';

const useV2Query: typeof useQuery = (query, options, ...rest) => {
  return useQuery(
    query,
    {
      ...options,
      context: {
        ...options?.context,
        useV2: true,
      },
    },
    ...rest,
  );
};

export default useV2Query;
